
/*@ngInject*/
const FormRulesController = function ($element, $rootScope, $scope, $stateParams, $q, authorizationConstants,
                                      configurationMediator, currentUserModel, formTemplateStatus, formViewerConstant, localization,
                                      uiFormTemplateModel, umStudioConstant, formViewerModel, loadingBarHandler, configurationActionsUtil) {

    $element.addClass('formRules');

    $scope.viewModel = {
        formRule: null,
        fieldRule: null,
        uiFormTemplate: null,
        focusOnRuleName: false,
        doSave: false
    };

    function initialize(uiFormTemplate) {
        uiFormTemplateModel.setUiFormTemplate(uiFormTemplate);
        $scope.viewModel.uiFormTemplate = uiFormTemplate;
        $scope.viewModel.formRule = uiFormTemplate.triggerRule;
        $scope.viewModel.canUserManageFormRules = canManageFormRules(uiFormTemplate);
        if(!_.isNil($stateParams.ruleName)) {
            uiFormTemplateModel.setSelectedFieldRuleName($stateParams.ruleName);
        }
    }

    function canManageFormRules(uiFormTemplate) {
        var isAuthorizedToManageForms = currentUserModel.hasAuthorization(authorizationConstants.MANAGE_FORMS);

        return formTemplateStatus.IN_PRODUCTION !== uiFormTemplate.formTemplate.status && isAuthorizedToManageForms;
    }

    $scope.$on(umStudioConstant.event.RULE_UPDATED, function () {
        $scope.viewModel.doSave = true;
        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_UPDATED);
    });

    $scope.$on(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, function () {
        $scope.viewModel.doSave = false;
    });

    configurationMediator.getFormTemplateById($stateParams.uiFormTemplateId).then(initialize);

    $scope.$on(umStudioConstant.event.FORM_RULE_SELECTED, function () {
        $scope.saveFormTemplate().then(function () {
            $scope.viewModel.formRule = uiFormTemplateModel.getUiFormTemplate().triggerRule;
            $scope.viewModel.fieldRule = null;
            uiFormTemplateModel.setCurrentSelectedRule('formRule');
        });
    });

        $scope.$on(umStudioConstant.event.FIELD_RULE_SELECTED, function (event, fieldRule, focusOnRuleName, isNewRule) {
            if (!_.isNil(isNewRule) && $scope.viewModel.doSave) {
                $scope.viewModel.doSave = false;
                $scope.viewModel.fieldRule = fieldRule;
                $scope.viewModel.formRule = null;
                $scope.viewModel.focusOnRuleName = focusOnRuleName;
                uiFormTemplateModel.setCurrentSelectedRule('fieldRule');
            } else {
                if (_.isNil(fieldRule) || _.isNil($scope.viewModel.fieldRule) || fieldRule.name !== $scope.viewModel.fieldRule.name)
                    $scope.saveFormTemplate().then(function () {
                        $scope.viewModel.fieldRule = fieldRule;
                        $scope.viewModel.formRule = null;
                        $scope.viewModel.focusOnRuleName = focusOnRuleName;
                        uiFormTemplateModel.setCurrentSelectedRule('fieldRule');
                        uiFormTemplateModel.setSelectedFieldRuleName(fieldRule.name.substr(0, _.indexOf(fieldRule.name, '-')));
                    });
            }
        });

    $scope.$on(umStudioConstant.event.RESET_RULE_SELECTION, function (event) {
        $scope.viewModel.fieldRule = null;
        $scope.viewModel.formRule = null;
    });

    $scope.saveFormTemplate = function () {
        var formStructure,
            uiFormTemplate,
            uiFormTemplateId = $scope.viewModel.uiFormTemplate.id,
            deferred = $q.defer();

        if ($scope.viewModel.doSave) {
            formStructure = formViewerModel.getFormStructure(uiFormTemplateId);
            if (formStructure) {
                configurationActionsUtil.populateUiFormTemplateModel(uiFormTemplateId);
                uiFormTemplate = formStructure.uiFormTemplate;
            } else {
                uiFormTemplate = uiFormTemplateModel.getUiFormTemplate();
            }
            loadingBarHandler.showLoadingBar('formEditor.saveUiFormTemplate.loadingBar');
            if (_.isNil(uiFormTemplate.id)) {
                configurationMediator.createFormTemplate(uiFormTemplate).then(function (uiFormTemplate) {
                    loadingBarHandler.hideLoadingBar();
                    configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
                        $scope.viewModel.doSave = false;
                        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
                        deferred.resolve();
                    });
                });
            } else {
                configurationMediator.updateFormTemplate(uiFormTemplate, uiFormTemplate.id).then(function (uiFormTemplate) {
                    loadingBarHandler.hideLoadingBar();
                    configurationActionsUtil.handleUiFormTemplateSave(uiFormTemplate, false).then(function () {
                        $scope.viewModel.doSave = false;
                        $rootScope.$broadcast(formViewerConstant.event.formBuilder.FORM_TEMPLATE_SAVED, uiFormTemplate);
                        deferred.resolve();
                    });
                });
            }
        } else {
            deferred.resolve();
        }
        return deferred.promise;
    };

    $scope.showConditionalMessage = function () {
        var conditionalFieldCount = 0;
        if (!_.isNil($scope.viewModel.uiFormTemplate) && _.isNil($scope.viewModel.formRule) && _.isNil($scope.viewModel.fieldRule)) {
            conditionalFieldCount = _.reduce($scope.viewModel.uiFormTemplate.formTemplate.fieldTemplates, function (count, fieldTemplate) {
                if (fieldTemplate.hidden) {
                    count++;
                }
                return count;
            }, 0);

            return conditionalFieldCount === 0;
        }

        return false;
    };

    $scope.showNoFieldRulesMessage = function () {
        if (!_.isNil($scope.viewModel.uiFormTemplate) && _.isNil($scope.viewModel.formRule) && _.isNil($scope.viewModel.fieldRule) && _.isEmpty($scope.viewModel.uiFormTemplate.fieldRules)) {
            return true;
        }

        return false;
    };

    $scope.createNewFieldRule = function () {
        $rootScope.$broadcast(umStudioConstant.event.CREATE_NEW_FIELD_RULE);
    };

    $scope.$on('$destroy', function () {
        uiFormTemplateModel.setUiFormTemplate(null);
    });
};

angular.module('ums.configuration')
    .controller('formRulesController', FormRulesController);
